import { Capacitor } from '@capacitor/core';

// 线上 PHP 后端的绝对地址（iOS 打包后的原生 App 页面来自 Capacitor 内置 localhost，
// 相对地址会打到自己身上，必须使用绝对地址）。
export const REMOTE_API_BASE = 'https://kendamatoolbox.cn/myapp';

// 线上站点根地址（不含 /myapp 子路径），用于拼装 Socket.io 等同源地址
export const REMOTE_SITE_ORIGIN = 'https://kendamatoolbox.cn';

// 登录/me 接口签发的 token 存储 key
export const AUTH_TOKEN_KEY = 'kendama_auth_token';

export const getAuthToken = (): string | null => {
  try {
    if (typeof window === 'undefined') return null;
    return window.localStorage.getItem(AUTH_TOKEN_KEY);
  } catch {
    return null;
  }
};

export const setAuthToken = (token?: string | null): void => {
  try {
    if (typeof window === 'undefined') return;
    if (!token) {
      window.localStorage.removeItem(AUTH_TOKEN_KEY);
    } else {
      window.localStorage.setItem(AUTH_TOKEN_KEY, token);
    }
  } catch {
    // 忽略本地存储异常
  }
};

// 附加鉴权请求头；有 token 时返回 { 'X-Kendama-Auth': token }，供跨域请求使用
export const phpAuthHeaders = (extra?: Record<string, string>): Record<string, string> => {
  const token = getAuthToken();
  const headers: Record<string, string> = token ? { 'X-Kendama-Auth': token } : {};
  return extra ? { ...headers, ...extra } : headers;
};

export const isNativeApp = (): boolean => {
  try {
    return typeof Capacitor !== 'undefined' && !!Capacitor.isNativePlatform?.();
  } catch {
    return false;
  }
};

// 是否为“本地 Node 开发后端”。打包后的原生 App 里没有本地后端，一律返回 false，
// 否则 hostname === 'localhost' 会让原生 App 误入本地分支。
export const isLocalBackend = (): boolean => {
  if (typeof window === 'undefined') return false;
  if (isNativeApp()) return false;
  if (import.meta.env.DEV) return true;
  const h = window.location.hostname;
  if (h === 'localhost' || h === '127.0.0.1' || h === '0.0.0.0' || h.endsWith('.local')) {
    return true;
  }
  if (/^10\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(h)) return true;
  if (/^192\.168\.\d{1,3}\.\d{1,3}$/.test(h)) return true;
  const m172 = h.match(/^172\.(\d{1,3})\./);
  if (m172) {
    const secondOctet = Number(m172[1]);
    if (secondOctet >= 16 && secondOctet <= 31) return true;
  }
  return false;
};

// 构造远程 PHP 接口地址（?action=xxx）。query 为额外的 “k=v&k2=v2” 片段。
// 原生 App：绝对地址指向线上；网页部署：继续使用相对 ./api.php，兼容 /myapp 子路径托管。
export const phpApiUrl = (action: string, query = ''): string => {
  const qs = query ? `&${query.replace(/^&/, '')}` : '';
  const suffix = `?action=${encodeURIComponent(action)}${qs}`;
  return isNativeApp() ? `${REMOTE_API_BASE}/api.php${suffix}` : `./api.php${suffix}`;
};
